import PropTypes from 'prop-types';
import { formatRawPhoneNumber } from '../../input/phone/utils/phoneNumberUtils';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyPhone = props => {
  const propertyValue = usePropertyValue();
  const {
    className,
    placeholder
  } = props;
  return /*#__PURE__*/_jsx("span", Object.assign({
    className: className
  }, getDataAttributes(props), {
    children: propertyValue ? formatRawPhoneNumber(propertyValue) : placeholder
  }));
};
FormattedPropertyPhone.displayName = 'FormattedPropertyPhone';
FormattedPropertyPhone.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.node
};
export default FormattedPropertyPhone;